import { render, staticRenderFns } from "./WithdrawPage.vue?vue&type=template&id=40d98e59"
import script from "./WithdrawPage.vue?vue&type=script&lang=js"
export * from "./WithdrawPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports